import {
  AccountOutlined,
  LocationOutlined,
  UnionPaymentOutlined,
  NotificationsOutlined,
  OrderOutlined,
  FavouriteAlternativeOutlined,
  AnonymousUserProfileOutlined,
  LocationPickerColored,
  CubeOutlined,
  CopyrightColored,
  HeartOutlined,
  BellOutlined,
} from '@teko/ds-icon';
import { NavItem } from 'types';

export const SHARED_NAV_ITEMS_TEXTS = {
  ACCOUNT_INFORMATION: 'Thông tin tài khoản',
  ORDER_MANAGEMENT: 'Quản lý đơn hàng',
  WISH_LIST: 'Sản phẩm yêu thích',
  ADDRESS_BOOK: 'Sổ địa chỉ',
  NOTIFICATION: 'Thông báo',
  PROMOTION_AND_UPDATE_NOTI: 'Ưu đãi & Cập nhật',
  ORDERS_NOTI: 'Đơn hàng',
  LOYALTY_HISTORY: 'Điểm thành viên',
};

export const SHARED_NAV_ITEMS_HREFS = {
  ACCOUNT_INFORMATION: '/account',
  ORDER_MANAGEMENT: '/account/orders',
  WISH_LIST: '/account/wish-list',
  ADDRESS_BOOK: '/account/addresses',
  NOTIFICATION: '/notification',
  PROMOTION_AND_UPDATE_NOTI: '/notification?type=promotion-and-update',
  ORDERS_NOTI: '/notification?type=orders',
  LOYALTY_HISTORY: '/my/loyalty-history',
};

export const SHARED_NAV_ITEMS: NavItem[] = [
  {
    icon: <AccountOutlined size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.ACCOUNT_INFORMATION,
    href: SHARED_NAV_ITEMS_HREFS.ACCOUNT_INFORMATION,
    contentName: 'viewAccountInfo',
    regionName: 'headerBar',
  },
  {
    icon: <OrderOutlined size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.ORDER_MANAGEMENT,
    href: SHARED_NAV_ITEMS_HREFS.ORDER_MANAGEMENT,
    contentName: 'viewOrder',
    regionName: 'headerBar',
  },
  {
    icon: <FavouriteAlternativeOutlined size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.WISH_LIST,
    href: SHARED_NAV_ITEMS_HREFS.WISH_LIST,
    contentName: 'viewWishList',
    regionName: 'headerBar',
  },
  {
    icon: <LocationOutlined size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.ADDRESS_BOOK,
    href: SHARED_NAV_ITEMS_HREFS.ADDRESS_BOOK,
    contentName: 'viewAddressList',
    regionName: 'headerBar',
  },
  {
    icon: <NotificationsOutlined size={18} className="noti" />,
    text: SHARED_NAV_ITEMS_TEXTS.NOTIFICATION,
    href: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
    anonymous: true,
    showByConfiguration: true,
    contentName: 'viewNotification',
    regionName: 'headerBar',
  },
  {
    icon: <UnionPaymentOutlined size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.LOYALTY_HISTORY,
    href: SHARED_NAV_ITEMS_HREFS.LOYALTY_HISTORY,
    contentName: 'viewLoyalty',
    regionName: 'headerBar',
  },
];

export const NEW_LAYOUT_NAV_ITEMS: NavItem[] = [
  {
    icon: <AnonymousUserProfileOutlined color="black" size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.ACCOUNT_INFORMATION,
    href: SHARED_NAV_ITEMS_HREFS.ACCOUNT_INFORMATION,
    contentName: 'viewAccountInfo',
    regionName: 'headerBar',
  },
  {
    icon: <CubeOutlined color="black" size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.ORDER_MANAGEMENT,
    href: SHARED_NAV_ITEMS_HREFS.ORDER_MANAGEMENT,
    contentName: 'viewOrder',
    regionName: 'headerBar',
  },
  {
    icon: <HeartOutlined color="black" size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.WISH_LIST,
    href: SHARED_NAV_ITEMS_HREFS.WISH_LIST,
    contentName: 'viewWishList',
    regionName: 'headerBar',
  },
  {
    icon: <LocationPickerColored color="black" size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.ADDRESS_BOOK,
    href: SHARED_NAV_ITEMS_HREFS.ADDRESS_BOOK,
    contentName: 'viewAddressList',
    regionName: 'headerBar',
  },
  {
    icon: <BellOutlined color="black" size={18} className="noti" />,
    text: SHARED_NAV_ITEMS_TEXTS.NOTIFICATION,
    href: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
    anonymous: true,
    showByConfiguration: true,
    contentName: 'viewNotification',
    regionName: 'headerBar',
  },
  {
    icon: <CopyrightColored size={18} />,
    text: SHARED_NAV_ITEMS_TEXTS.LOYALTY_HISTORY,
    href: SHARED_NAV_ITEMS_HREFS.LOYALTY_HISTORY,
    contentName: 'viewLoyalty',
    regionName: 'headerBar',
  },
];
